import { useSession } from "@outschool/ui-auth";

import { useFeatureFlag } from "../lib/FeatureFlags";

const TEACHER_UNIFIED_MESSAGING_INBOX_FEATURE_FLAG =
  "teacher-unified-messaging-inbox";

export function useTeacherUnifiedMessaging() {
  return useFeatureFlag(TEACHER_UNIFIED_MESSAGING_INBOX_FEATURE_FLAG);
}

export function useSellerOrgUnifiedInbox() {
  const { currentUser } = useSession();
  const isTeacherUnifiedMessagingEnabled = useTeacherUnifiedMessaging();
  return (
    isTeacherUnifiedMessagingEnabled &&
    !!currentUser?.sellerOrg?.currentUserIsOwner
  );
}
